module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/crypto-app-6-b0aa7356864f4ff6324d3ea4e66fd29f.png";